import React from "react"
import PropTypes from "prop-types"
import { Button, Flex, Tooltip } from "antd"
import { useTranslation } from "react-i18next"
import { CALENDAR_TABS } from "../../constants"
import styles from "../../Calendar.module.css"

const BookingTypeTabs = ({ activeTab, hasMyBookings, onChangeFilters }) => {
  const { t } = useTranslation()

  const handleTabChange = (tab) => onChangeFilters({ target: { name: "tab", value: tab } })

  const extraTabs = [
    { key: CALENDAR_TABS.CREW, label: t("calendar.tabs.crew", "Crew") },
    { key: CALENDAR_TABS.EQUIPMENT, label: t("calendar.tabs.equipment", "Equipment") },
  ]

  return (
    <Flex gap={8} className={`px-s py-xs ${styles.bookingTypeButtons}`}>
      <Button size="middle" type={activeTab === CALENDAR_TABS.ALL_BOOKINGS ? "primary" : "default"} onClick={() => handleTabChange(CALENDAR_TABS.ALL_BOOKINGS)}>
        {t("calendar.tabs.all_bookings", "All Bookings")}
      </Button>
      <Tooltip title={hasMyBookings === false ? t("calendar.tabs.no_my_bookings", "No bookings assigned to you") : null}>
        <span>
          <Button size="middle" type={activeTab === CALENDAR_TABS.MY_BOOKINGS ? "primary" : "default"} onClick={() => handleTabChange(CALENDAR_TABS.MY_BOOKINGS)} className={hasMyBookings ? "" : styles.disabledButton} disabled={!hasMyBookings}>
            {t("calendar.tabs.my_bookings", "My Bookings")}
          </Button>
        </span>
      </Tooltip>
      {extraTabs.map(({ key, label }) => (
        <Button key={key} size="middle" type={activeTab === key ? "primary" : "default"} onClick={() => handleTabChange(key)}>
          {label}
        </Button>
      ))}
    </Flex>
  )
}

BookingTypeTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  hasMyBookings: PropTypes.bool,
  onChangeFilters: PropTypes.func.isRequired,
}

export default BookingTypeTabs
